import * as type from '../mutation-types'

/*
  * @desc 记录路由切换次数
  * @arg {object} state 状态
  * 在导航守卫里调用这些方法，一进入页面length会加一，所以初始值为-1，进入首页时为0，返回时会先加一，所以需要减一再减一
*/

const state = {
  historyLength: -1
}

const getters = {
  historyLength: state => state.historyLength
}

const actions = {
  addHistoryLength ({commit}, num) { // 增加
    commit(type.ADDHISTORYLENGTH, num)
  },
  minusHistoryLength ({commit}, num) { // 减去:（减去一个页面是减 2 ）,在调用$router.replace 之前调用该方法 减 1
    commit(type.MINUSHISTORYLENGTH, num)
  },
  initHistoryLength ({commit}, num) { // 初始化（无返回按钮）
    commit(type.INITHISTORYLENGTH, num)
  }
}

const mutations = {
  [type.ADDHISTORYLENGTH] (state, num) {
    state.historyLength++
  },
  [type.MINUSHISTORYLENGTH] (state, num) {
    state.historyLength = state.historyLength - num
  },
  [type.INITHISTORYLENGTH] (state, num) {
    state.historyLength = -1
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/historyBack.js